module.exports = __webpack_public_path__ + "static/img/guide_img_0.3152a689.jpg";